import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "intermiadiate-block" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row d-flex align-items-center mb-3 mt-3" }
const _hoisted_5 = { class: "d-flex col-12 col-md-4 align-items-md-center order-2 order-md-1" }
const _hoisted_6 = { class: "left-result" }
const _hoisted_7 = {
  key: 0,
  class: "fs-6 fw-bold text-dark"
}
const _hoisted_8 = {
  key: 1,
  class: "fs-6"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 mx-2 fw-normal" }, "vs", -1)
const _hoisted_10 = { class: "right-result" }
const _hoisted_11 = {
  key: 0,
  class: "fs-6 fw-normal"
}
const _hoisted_12 = {
  key: 1,
  class: "fs-6 fw-bold text-dark"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12 col-md-4 text-md-center order-1 order-md-2"
}
const _hoisted_14 = { class: "fs-6" }
const _hoisted_15 = { class: "col-12 col-md-4 ms-auto d-flex align-items-md-center justify-content-md-end ms-auto order-3 order-md-3" }
const _hoisted_16 = { class: "left-result" }
const _hoisted_17 = {
  key: 0,
  class: "fw-bold text-dark"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 mx-2" }, "/", -1)
const _hoisted_20 = { class: "right-result" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "fw-bold text-dark"
}
const _hoisted_23 = {
  key: 1,
  class: "row d-flex mb-3 mt-3"
}
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_26 = { class: "col-12 col-md-6 d-flex justify-content-md-end ms-auto" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  class: "fs-6 ms-1 text-lowercase",
  style: {"align-items":"flex-end","display":"flex"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitInputMask = _resolveComponent("MrUiKitInputMask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (int, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'result-int-' + index,
          class: "row-result"
        }, [
          (int.competitionResultType.haveDoubleResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (int.isLeft)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(int.entity), 1))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(int.opponent), 1))
                    ]),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      (int.isLeft)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_11, _toDisplayString(int.opponent), 1))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_12, _toDisplayString(int.entity), 1))
                    ])
                  ]),
                  (int.notes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(int.notes), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (int.isLeft)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_17, _toDisplayString(int.leftResult), 1))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_18, _toDisplayString(int.rightResult), 1))
                    ]),
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      (int.isLeft)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_21, _toDisplayString(int.rightResult), 1))
                        : (_openBlock(), _createElementBlock("h4", _hoisted_22, _toDisplayString(int.leftResult), 1))
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (int.notes)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(int.notes), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_MrUiKitInputMask, {
                    modelValue: int.leftResult,
                    "onUpdate:modelValue": ($event: any) => ((int.leftResult) = $event),
                    mask: int.competitionResultType.regex,
                    disabled: true,
                    classes: ['mb-n4']
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "mask"]),
                  (int.rightResult)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "/"))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", _hoisted_28, _toDisplayString(int.rightResult), 1)
                ])
              ]))
        ]))
      }), 128))
    ])
  ]))
}